import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CommentData } from "api/commonApi";
import "./Reply.scoped.scss";
import CommentsLoading from "components/common/loading/CommentsLoading";
import { useTranslation } from "react-i18next";
import { useInfiniteScrollQuery } from "api/replyApi";
import ReplyFrame from "./ReplyFrame";

function Reply() {
  const { t } = useTranslation();
  const { idx } = useParams();
  const [nextPageBtn, setNextPageBtn] = useState(false);

  const { getBoard, getNextPage, getBoardIsSuccess, getNextPageIsPossible } =
    useInfiniteScrollQuery({ idx });

  useEffect(() => {
    if (getNextPageIsPossible) {
      setNextPageBtn(true);
    } else {
      setNextPageBtn(false);
    }
  }, [nextPageBtn, getBoard]);

  return (
    <div id="replys">
      <div className="reply">
        {getBoardIsSuccess ? (
          getBoard?.pages[0].result === 1 ? (
            Number(idx) === getBoard?.pages[0].boardpage[0].board_idx ? (
              getBoard.pages.map((pageData) =>
                pageData.boardpage.map((i: CommentData) =>
                  // 부모 댓글
                  i.comment_idx === 0 ? (
                    <ReplyFrame type="reply" data={i} key={i.idx} />
                  ) : (
                    // 자식 댓글
                    <ReplyFrame data={i} key={i.idx} type="re-reply" />
                  )
                )
              )
            ) : (
              <CommentsLoading />
            )
          ) : null
        ) : // <CommentsLoading />
        null}
      </div>
      {nextPageBtn && getBoard?.pages[0].result === 1 ? (
        <div onClick={() => getNextPage()} className="moreBtn">
          {t("more_comments")}
        </div>
      ) : null}
    </div>
  );
}

export default Reply;
